import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

import { sectionHeading } from '../../styled';

export const BenefitsContainerRow = styled(Row)`
  width: 100%;
`;

export const BenefitsHeader = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x7spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
  }
`;

export const BenefitsContentRow = styled(Row)`
  margin: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
     margin: ${({ theme }) => theme.x8spacePx}px 0 0;
  `}
  img {
    width: 100%;
    ${media.lgUp`
      max-width: 470px;
    `}
    ${media.xlUp`
      max-width: 600px;
    `}
  }
`;

export const StyledReactMarkdown = styled('div')`
  margin-bottom: ${({ theme }) => theme.x6spacePx}px;
  ${media.mdOnly`
    margin-left: ${({ theme }) => theme.x4spacePx}px;
  `};
  ${media.lgUp`
    margin: 0 ${({ theme }) => theme.x8spacePx}px;
  `};
  h4 {
    ${({ theme }) => theme.typography.megaStrong};
    color: ${({ theme }) => theme.color.spaceGray};
    margin: ${({ theme }) => theme.x2spacePx}px 0
      ${({ theme }) => theme.x1spacePx}px;
    letter-spacing: -0.02em;
    ${media.mdUp`
      margin-top: 0;
    `};
  }
  p {
    font-size: 16px;
    color: ${({ theme }) => theme.color.spaceGray};
    ${media.mdUp`
      padding-bottom: ${({ theme }) => theme.x3spacePx}px;
      ${({ theme }) => theme.typography.base};
    `}
  }
`;

export const VideoContainer = styled('div')`
  overflow: hidden;
  padding-bottom: 56%;
  margin: 0 ${({ theme }) => theme.x2spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  position: relative;
  height: 0;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x8spacePx}px 0 ${({ theme }) =>
      theme.x3spacePx}px;
  `};
  iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
`;
